/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON, FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON, } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponse';
import { FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON, FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON, } from './FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultError';
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse interface.
 */
export function instanceOfFxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse(value) {
    if (!('Success' in value) || value['Success'] === undefined)
        return false;
    if (!('Data' in value) || value['Data'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Success': json['Success'],
        'Data': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseFromJSON(json['Data']),
        'Error': json['Error'] == null ? undefined : FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorFromJSON(json['Error']),
    };
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSON(json) {
    return FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Success': value['Success'],
        'Data': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationResponseToJSON(value['Data']),
        'Error': FxGamesLibWebRpcContractsFxGamesResponseOfWeChatLoginResultErrorToJSON(value['Error']),
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsFxGamesResponseOfFxIdAuthenticationResponse.js.map